import { h } from 'preact';
import { Skeleton } from './Skeleton';
import styles from '../../pages/Pages.module.scss';
export function ProductCountSkeleton() {
    return (h("div", { class: styles.productCount },
        h(Skeleton, { width: "200px", height: "14px", borderRadius: "4px" })));
}
